export default {
    UPDATE_ALL_FIRST_FLOW_LIST: (state, payload) => {
        state.allFirstFlowList = payload;
    },
    UPDATE_SYMBOL_LIST: (state, payload) => {
        state.symbolList = payload;
        state.symbolStringList = payload.filter((item) => {
            return (item.id === 0 || item.type.find((val) => {return val.toLowerCase() === 'string'}));
        });
        state.symbolNumberList = payload.filter((item) => {
            return (item.id === 0 || item.type.find((val) => {return val.toLowerCase() === 'number'}));
        });
    },
    UPDATE_VARIABLE_LIST: (state, payload) => {
        state.variableList = payload;
        state.variableStringList = payload.filter((item) => {
            return (item.id === 0 || item.type.toLowerCase() === 'string');
        });
    //  state.variableNumberList = payload.filter((item) => {
    //   return (item.id === 0 || item.type.toLowerCase() === 'number');
    // });
    },
    UPDATE_REPLY_TYPE_LIST: (state, payload) => {
        state.replyTypeList = payload;
    },
    UPDATE_INTENT_TYPE_LIST: (state, payload) => {
        state.intentTypeList = payload;
    },
    UPDATE_API_CONFIG_LIST: (state, payload) => {
        state.apiConfigList = payload;
    },
    UPDATE_TIER_MASTER_DATA_LIST: (state, payload) => {
        state.tierMasterdataList = payload;
    },
    UPDATE_LANGUAGE_ACTIVE_ID: (state, payload) => {
        state.languageActiveId = payload;
    },
}